import styles from "./styles.module.css";
import { MdChevronRight } from "react-icons/md";

export default function ListItem({ title, active, index, onClick }) {
  return (
    <div
      className={`${styles.item} ${active ? styles.active : ""}`}
      onClick={() => onClick(index)}
    >
      <div>{title}</div>
      <MdChevronRight className={styles.arrowIcon} />
    </div>
  );
}
